import { useEffect, useRef } from "react";

import useAxiosPrivate from "@/api/hooks/useAxiosPrivate";
import Table from "@/components/Table/Table";
import useResponse from "@/shared/hooks/useResponse";
import { useUsersInvitationsTableStore } from "@/stores/useTableStore";

import LayoutWrapper from "../../../components/Layout/LayoutWrapper";
import UsersHeaderActions from "../../../components/PageHeader/actions/pageHeaderActions/UsersHeaderActions/UsersHeaderActions";
import TabFilters from "../../../components/TabFilters/TabFilters";
import UsersInvitationsActionDialog from "../../../components/Table/actions/dialogs/Users/UsersInvitations/UsersInvitationsActionDialog/UsersInvitationsActionDialog";
import useUsersInvitationsActions from "../../../components/Table/actions/inlineActions/hooks/useUsersInvitationsActions";
import { ROUTES, TABLE_NAMES } from "../../../shared";

import { USERS_PAGE_TABS } from "./config";

const UsersInvitations = () => {
  const { getData } = useAxiosPrivate();
  const { handleResponse } = useResponse();
  const { setIsCheckable, setInlineActions, resetInitialLoading, fetchData } =
    useUsersInvitationsTableStore();

  const { userInvitationActions, inlineActions, userEmail, handleCloseDialog } =
    useUsersInvitationsActions();

  const hasFetched = useRef(false);

  useEffect(() => {
    if (!hasFetched.current) {
      resetInitialLoading();
      hasFetched.current = true;
      handlePageLoad();
    }
  }, []);

  const handlePageLoad = async () => {
    await fetchData(getData, handleResponse);
    setIsCheckable(false);
    setInlineActions(inlineActions);
  };

  return (
    <>
      <LayoutWrapper
        showDetailsSection={false}
        tableName={TABLE_NAMES.Users}
        route={ROUTES.UsersInvitations}
      >
        <UsersHeaderActions currentRoute={ROUTES.UsersInvitations} />
      </LayoutWrapper>
      <Table
        route={ROUTES.UsersInvitations}
        hideFilters
        hasDetails={false}
        tabFilters={<TabFilters tabs={USERS_PAGE_TABS} />}
        hasTabFilters
      />

      {/* inline action dialog */}
      {userInvitationActions.map(({ title, open, dialogAction, resource }) => (
        <UsersInvitationsActionDialog
          key={title}
          isOpen={open}
          userEmail={userEmail}
          onClose={handleCloseDialog}
          dialogAction={dialogAction}
          apiResource={resource}
          testId={title}
        />
      ))}
    </>
  );
};

export default UsersInvitations;
